import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getACDetailByRouteName } from "../apis/shared.api";

const PermissionContext = createContext();

export const PermissionAccessControlProvider = ({ children }) => {
  const { pathname } = useLocation();
  const [permissionRoute, setPermissionRoute] = useState([]);
  // const hasFetched = useRef(false);

  useEffect(() => {
    // if (hasFetched.current) return;

    getACDetailByRouteName(pathname, (result) => {
      if (result && result.permissions.length) {
        setPermissionRoute(
          result.permissions.map((permission) => ({
            ...permission,
            title: result.name,
          }))
        );
      }
    });

    // hasFetched.current = true;
  }, [pathname]);

  return (
    <PermissionContext.Provider value={permissionRoute}>
      {children}
    </PermissionContext.Provider>
  );
};

export const useGetPermissionAccessControl = () => {
  return useContext(PermissionContext);
};
